import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';

export const DATE_TIME_INPUT_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

export const DATE_ONLY_INPUT_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

export type DatepickerInternalContent = {
  _model?: {
    selectionChanged: Observable<{ selection: unknown }>;
    updateSelection(value: Date, source: unknown): void;
  };
  _changeDetectorRef?: { markForCheck(): void };
};

@Injectable()
export class DatepickerV2DateAdapter extends NativeDateAdapter {
  private _hubTimezone: string | null = null;

  setHubTimezone(timezone: string): void {
    this._hubTimezone = timezone;
  }

  override format(date: Date, displayFormat: object): string {
    const opts = displayFormat as Intl.DateTimeFormatOptions;
    if (opts.hour !== undefined) {
      const locale = this.locale as string;
      const timeZone = this._hubTimezone ?? 'utc';
      const dateToFormat = this._hubTimezone
        ? date
        : new Date(
            Date.UTC(
              date.getFullYear(),
              date.getMonth(),
              date.getDate(),
              date.getHours(),
              date.getMinutes(),
              date.getSeconds(),
              date.getMilliseconds(),
            ),
          );
      const fmt = (o: Intl.DateTimeFormatOptions): string =>
        new Intl.DateTimeFormat(locale, { timeZone, ...o }).format(dateToFormat);
      return `${fmt({ year: 'numeric', month: 'long', day: 'numeric' })} ${fmt({
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })}`;
    }
    return super.format(date, displayFormat);
  }
}

export function createDatepickerV2Formats(): MatDateFormats {
  return {
    parse: { dateInput: DATE_TIME_INPUT_FORMAT },
    display: {
      dateInput: DATE_TIME_INPUT_FORMAT,
      monthYearLabel: { year: 'numeric', month: 'short' },
      dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
      monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
  };
}

export const DATEPICKER_V2_DATE_FORMATS: MatDateFormats = createDatepickerV2Formats();
